import { forwardRef, useRef } from "react";
import ModalBase, { IModalBaseProps, ModalBaseRefType } from "../../../../Base/ModalBase";
import CorrecaoContabilFormBasic, { ICorrecaoContabilFormBasicRef } from "./CorrecaoContabilFormBasic";
import TypeViagem from "../../../../../Models/Domain/Viagem/Viagem";
import { CorrecaoContabil } from "../../../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import { useCorrecaoContabilSalvar } from "../../../../../Services/Domain/Viagem/Financeiro/CorrecaoContabilServices";
import dayjs from "dayjs";

interface ICorrecaoContabilFormModalProps extends IModalBaseProps {
    correcaoContabil?:CorrecaoContabil;
}
export default function CorrecaoContabilFormModal (
    {
        correcaoContabil,
        textButtonOpen,
        propsButtonOpen,
        title,
        width,
        destroyOnClose,
        ...props
    }:ICorrecaoContabilFormModalProps
) {
    textButtonOpen = textButtonOpen ?? ((correcaoContabil?.codigo ?? 0) > 0 ? "Editar" : "Adicionar");
    title = title ?? ((correcaoContabil?.codigo ?? 0) > 0 ? "Editar ajuste contábil" : "Adicionar ajuste contábil");
    propsButtonOpen = propsButtonOpen ?? {};
    propsButtonOpen.size = propsButtonOpen.size ?? "middle";
    width = width ?? "80vw";
    destroyOnClose = destroyOnClose ?? true;

    const refModal = useRef<ModalBaseRefType|null>(null);
    const refForm = useRef<ICorrecaoContabilFormBasicRef|null>(null);

    const {
        isPending,
        mutate
    } = useCorrecaoContabilSalvar({
        onSuccess(data, variables, context) {
            refModal.current?.fechar();
            refForm.current?.resetFields();
        },
    });

    return <ModalBase 
        ref={refModal}
        title={title}
        textButtonOpen={textButtonOpen}
        propsButtonOpen={propsButtonOpen}
        width={width}
        destroyOnClose={destroyOnClose}
        confirmLoading={isPending}
        onOk={() => refForm.current?.submit()}
        {...props}
    >
        <CorrecaoContabilFormBasic  
            ref={refForm}
            fieldsDisabled={{
                codViagem : (correcaoContabil?.codViagem ?? 0) > 0
            }}
            initialValues={{
                ...(correcaoContabil ?? {} as CorrecaoContabil),
                dataPagamento : (correcaoContabil?.dataPagamento ?? null) !== null ? dayjs(correcaoContabil?.dataPagamento) : undefined
            }}
            onFinish={mutate}
        />
    </ModalBase>;
};